import { Component, inject, Input } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import { PaySessionStatistics } from '../../../smoothr-web-app-core/models/PaySessionStatistics';
import { numberD } from '../../../smoothr-web-app-core/utils/utils';

@Component({
	selector: 'app-pay-session-statistics',
	templateUrl: './pay-session-statistics.component.html',
	styleUrls: ['./pay-session-statistics.component.scss'],
	imports: [IonicModule, TranslateModule],
})
export class PaySessionStatisticsComponent {
	@Input() paySessionStatistics: PaySessionStatistics | null = null;
	@Input() showDues: boolean = false;
	@Input() showTotal: boolean = false;
	@Input() showTips: boolean = false;
	@Input() showPaid: boolean = false;
	@Input() showSelected: boolean = false;
	@Input() showChecks: boolean = true;
	@Input() showTable: boolean = true;
	@Input() topayAmount: number | null = null;
	@Input() remainingAmount: number | null = null;
	currencyFormat: Intl.NumberFormat | null = null;
	private repositoryService = inject(RepositoryService);

	constructor() {
		this.currencyFormat = this.repositoryService.currencyFormat;
	}

	get formattedPaid() {
		return this.currencyFormat?.format(this.paySessionStatistics?.paidTotalPrice ?? 0);
	}

	get formattedDue() {
		return this.currencyFormat?.format(this.paySessionStatistics?.totalDue ?? 0);
	}

	get formattedToPayAmount() {
		return this.currencyFormat?.format(this.topayAmount ?? 0);
	}

	get formattedSelected() {
		return this.currencyFormat?.format(this.paySessionStatistics?.selectedTotalPrice ?? 0);
	}

	get formattedTotal() {
		return this.currencyFormat?.format(this.paySessionStatistics?.totalPrice ?? 0);
	}

	get hasTotalDiscount() {
		return this.paySessionStatistics?.totalDiscount !== 0;
	}

	get formattedTotalDiscount() {
		return this.currencyFormat?.format(this.paySessionStatistics?.totalDiscount ?? 0);
	}

	get formattedSelectedDiscount() {
		return this.currencyFormat?.format(this.paySessionStatistics?.selectedDiscount ?? 0);
	}

	get formattedTips() {
		return this.currencyFormat?.format(this.paySessionStatistics?.tipsValue ?? 0);
	}

	get formattedTotalTax() {
		return this.currencyFormat?.format(this.paySessionStatistics?.totalTax ?? 0);
	}

	get formattedRemainingAmount() {
		return this.currencyFormat?.format(this.remainingAmount ?? 0);
	}

	format(sum: number): string {
		return this.currencyFormat?.format(numberD(sum)) ?? '';
	}
}
